import { AjaxRequestOptions } from '@amzn/aac-chrome-internal-api';
import { composeMetricSlug } from 'src/commons/utils/async-request';
import logError from 'src/commons/utils/async-request/log-error';
import { AjaxRequestPublisher } from 'src/commons/utils/metrics';

const ChromeInternalApiRequestConfig: AjaxRequestOptions = {
  emitLatencyMetric: ({ endpoint, latency, method }) => {
    const { latencyMetricSlug } = composeMetricSlug({
      endpoint,
      method,
    });
    AjaxRequestPublisher.publishTimerMonitor(latencyMetricSlug, latency);
  },
  emitSuccessMetric: ({ endpoint, isSuccess, method }) => {
    const { successMetricSlug } = composeMetricSlug({
      endpoint,
      method,
    });
    AjaxRequestPublisher.publishCounterMonitor(
      successMetricSlug,
      isSuccess === true ? 1 : 0,
    );
  },
  logError: ({ endpoint, error, method }) => {
    const { sanitizedUrl, metricSlug } = composeMetricSlug({
      endpoint,
      method,
    });
    logError({
      error,
      loggerMessage: `Failed ${method} request to '${sanitizedUrl}'`,
      metricSlug,
    });
  },
};

export default ChromeInternalApiRequestConfig;
